import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_beverages: FaireCategoryEntity = {
  token: "cat_food-beverages",
  type: "category",
  name: "Beverages",
  level: 2,
  parentToken: "cat_food-drink",
  href: "/category/beverages",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
